module.exports = __webpack_public_path__ + "static/media/doctorPa.8394e8be.png";